//Formats number with commas to denote thousands
//Example: "1234567" returns "1,234,567"
export default function formattedNum(value) {
	let numberFormatter = new Intl.NumberFormat("en-US");

	return value && !isNaN(value) && numberFormatter.format(value)
		? numberFormatter.format(value)
		: "";
}
